<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <div class="module-blat container">
            <section class="module-header color-1 font-bold font-variable">{{ $t("BLATResult") }}</section>
            <section class="module-controls">
                <default-search v-model="keyword" width="var(--size-496-432-432)" :placeholder="$t('SearchPlaceholder')" />
                <ui-button :width="112" @click="methods.download">{{ $t("Download") }}</ui-button>
            </section>

            <section class="module-content">
                <diagram :data="data" :option="vars.option" @advanced="methods.sort"></diagram>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
import { Diagram } from "@/components/visualizations";
//* 组件属性
import { useComposable } from "./src/composable";

//* 插件
const route = useRoute();
//* 组合函数
const { vars, refs, methods, computeds } = useComposable();
const { keyword } = refs;
const { data } = computeds;

onBeforeUnmount(() => vars.timeout && clearInterval(vars.timeout));
onMounted(() => {
    if (route.params.id) methods.data(route.params.id as string);
    else {
        routerPush({ name: "BLAT", replace: true });
    }
});
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
